import React, { Component } from 'react';
import { Confirm, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { isNull, sortBy } from 'lodash';
import * as classnames from 'classnames';
import ReorderTool from './ReorderTool';
import { setProjectAnalysisActiveLayerId } from '../../data/analysis/layersActions';
import {
  createNewLayer,
  deleteLayer,
  layerSortingDownHandler,
  layerSortingUpHandler,
  toggleLayerVisibility
} from '../../data/analysis/layersDispatchers';

class LayersBox extends Component {
  constructor(props) {
    super(props);

    this.setActiveLayer = this.setActiveLayer.bind(this);
    this.createLayer = this.createLayer.bind(this);
    this.deleteLayer = this.deleteLayer.bind(this);
    this.closeDeleteLayerDialog = this.closeDeleteLayerDialog.bind(this);
    this.setDeleteLayerDialog = this.setDeleteLayerDialog.bind(this);
    this.upHandler = this.upHandler.bind(this);
    this.downHandler = this.downHandler.bind(this);
    this.state = {
      deleteLayer: {
        open: false,
        layer: null
      }
    };
  }

  setActiveLayer(id) {
    this.props.dispatch(setProjectAnalysisActiveLayerId(id));
  }

  setDeleteLayerDialog(layer) {
    this.setState({
      deleteLayer: {
        open: true,
        layer
      }
    });
  }

  createLayer() {
    if (this.props.project) {
      this.props.dispatch(createNewLayer(this.props.project.id));
    }
  }

  toggleLayerVisibility(id) {
    this.props.dispatch(toggleLayerVisibility(id));
  }

  closeDeleteLayerDialog() {
    this.setState({
      deleteLayer: {
        open: false,
        layer: null
      }
    });
  }

  deleteLayer() {
    if (!isNull(this.state.deleteLayer.layer)) {
      this.props.dispatch(deleteLayer(this.state.deleteLayer.layer));
    }
    this.closeDeleteLayerDialog();
  }

  upHandler() {
    this.props.dispatch(layerSortingUpHandler());
  }

  downHandler() {
    this.props.dispatch(layerSortingDownHandler());
  }

  render() {
    const deleteLayerDialog = this.state.deleteLayer.layer
      ? `Delete ${this.state.deleteLayer.layer.name} ?`
      : null;
    return (
      <div className="configurationBox">
        <Confirm
          key="confirmLayerDelete"
          open={this.state.deleteLayer.open}
          cancelButton="Cancel"
          confirmButton="Delete"
          content={deleteLayerDialog}
          onCancel={this.closeDeleteLayerDialog}
          onConfirm={this.deleteLayer}
        />
        <ReorderTool
          upHandler={this.upHandler}
          downHandler={this.downHandler}
          clearHandler={() => {
            this.setActiveLayer(null);
          }}
        />
        <Grid className="layersList">
          {sortBy(this.props.layers, layer => {
            return this.props.layersSorting.indexOf(layer.id);
          }).map((item, index) => {
            const rowClassNames = classnames({
              layer: true,
              active: this.props.activeLayerId === item.id,
              odd: index % 2 === 0
            });

            const iconClassName = classnames({
              iconContainer: true,
              disabled: this.props.visibleLayerIds.indexOf(item.id) < 0
            });

            return (
              <Grid.Row
                className={rowClassNames}
                key={item.id}
                onClick={e => {
                  if (e.target.closest('.iconContainer') === null) {
                    this.setActiveLayer(item.id);
                  }
                }}
              >
                <Grid.Column width={2} className={iconClassName}>
                  <i
                    onClick={() => {
                      this.toggleLayerVisibility(item.id);
                    }}
                    className="icon icon-eye clickable"
                  />
                </Grid.Column>
                <Grid.Column width={12} className="layerName clickable">
                  {item.name}
                </Grid.Column>
                <Grid.Column width={2} className="layerName clickable">
                  <span
                    onClick={e => {
                      this.setDeleteLayerDialog(item);
                    }}
                    className="icon-bin2"
                  />
                </Grid.Column>
              </Grid.Row>
            );
          })}

          <Grid.Row className="newLayer clickable" onClick={this.createLayer}>
            <Grid.Column width={2} className="iconContainer">
              <i className="icon icon-plus" />
            </Grid.Column>
            <Grid.Column width={14}>New Layer</Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active,
  layers: state.analysis.single.layers,
  activeLayerId: state.analysis.single.activeLayerId,
  layersSorting: state.analysis.single.layersSorting,
  visibleLayerIds: state.analysis.single.visibleLayerIds
}))(LayersBox);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/LayersBox.js